import { apiClient } from './client';
import type { KnowledgeArticle, ArticleNote } from '../types';

export interface KBListParams {
  category?: string;
  search?: string;
  status?: string;
  visibility?: string;
  page?: number;
  limit?: number;
}

export const kbApi = {
  list: async (params: KBListParams = {}) => {
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => v !== undefined && searchParams.set(k, String(v)));
    const res = await apiClient.get(`/kb?${searchParams}`);
    return res.data.data as { articles: KnowledgeArticle[]; total: number; page: number; limit: number };
  },

  getBySlug: async (slug: string) => {
    const res = await apiClient.get(`/kb/${slug}`);
    return res.data.data.article as KnowledgeArticle;
  },

  create: async (data: {
    title: string;
    content: string;
    excerpt?: string;
    category?: string;
    tags?: string[];
    status?: string;
    visibility?: string;
  }) => {
    const res = await apiClient.post('/kb', data);
    return res.data.data.article as KnowledgeArticle;
  },

  update: async (id: string, data: {
    title?: string;
    content?: string;
    excerpt?: string;
    category?: string;
    tags?: string[];
    status?: string;
    visibility?: string;
  }) => {
    const res = await apiClient.put(`/kb/${id}`, data);
    return res.data.data.article as KnowledgeArticle;
  },

  delete: async (id: string) => {
    await apiClient.delete(`/kb/${id}`);
  },

  feedback: async (id: string, helpful: boolean) => {
    await apiClient.post(`/kb/${id}/feedback`, { helpful });
  },

  getNotes: async (id: string) => {
    const res = await apiClient.get(`/kb/${id}/notes`);
    return res.data.data.notes as ArticleNote[];
  },

  addNote: async (id: string, content: string) => {
    const res = await apiClient.post(`/kb/${id}/notes`, { content });
    return res.data.data.note as ArticleNote;
  },

  deleteNote: async (articleId: string, noteId: string) => {
    await apiClient.delete(`/kb/${articleId}/notes/${noteId}`);
  },
};
